import React, { useEffect, useState } from "react";
import { DownloadSimple, Export } from "@phosphor-icons/react";

let deferredPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferredPrompt = e; });
}

export function InstallAppButton() {
  const [canPrompt, setCanPrompt] = useState(!!deferredPrompt);
  const [showIos, setShowIos] = useState(false);
  const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const installed = window.matchMedia?.("(display-mode: standalone)").matches;

  useEffect(() => {
    const h = (e) => { e.preventDefault(); deferredPrompt = e; setCanPrompt(true); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);

  const install = async () => {
    if (deferredPrompt) { deferredPrompt.prompt(); await deferredPrompt.userChoice; deferredPrompt = null; setCanPrompt(false); return; }
    setShowIos(true);
  };

  if (installed) return null;
  return (
    <div className="relative">
      <button onClick={install} data-testid="install-app-btn"
        className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-gradient-to-r from-sky-500 to-emerald-500 text-white font-semibold hover:brightness-110 transition-[filter]">
        <DownloadSimple size={18} weight="bold" />Download App
      </button>
      {showIos && !canPrompt && (
        <p className="mt-3 text-xs text-white/70 bg-white/5 border border-white/10 rounded-xl px-3 py-2 max-w-xs" data-testid="install-app-help">
          {isIos ? <>Tap <Export size={13} className="inline" /> Share in Safari, then <b>Add to Home Screen</b>.</> : <>Open your browser menu and choose <b>Install App</b> or <b>Add to Home Screen</b>.</>}
        </p>
      )}
    </div>
  );
}
